var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 107,
    viewBox: "0 0 108 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 46.0764V1.5H46.0764V46.0764H1.5Z",
    stroke: "#6C7189"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3164 105.33V60.7539H105.893V105.33H61.3164Z",
    stroke: "#6C7189"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3164 46.0764V1.5H105.893V46.0764H61.3164Z",
    stroke: "#6C7189"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5764 1H1V46.5764H46.5764V1Z",
    stroke: "#6C7189",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.393 60.2539H60.8164V105.83H106.393V60.2539Z",
    stroke: "#6C7189",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8548 71.3086H72.9941V79.7634H92.8548V71.3086Z",
    stroke: "#6C7189",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3887 15.6611H33.2493",
    stroke: "#6C7189",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3887 24.1162H33.2493",
    stroke: "#6C7189",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3887 32.5479H33.2493",
    stroke: "#6C7189",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9941 87.1875H92.8548",
    stroke: "#6C7189",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9941 94.4014H92.8548",
    stroke: "#6C7189",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.393 1H60.8164V46.5764H106.393V1Z",
    stroke: "#6C7189",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4072 64.8334C11.4072 79.6531 23.3895 91.6668 38.1704 91.6668C52.9513 91.6668 64.9336 79.6531 64.9336 64.8334C64.9336 50.0137 52.9513 38 38.1704 38C23.3895 38 11.4072 50.0137 11.4072 64.8334Z",
    fill: "#1D1F52",
    stroke: "#6C7189",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5352 84L5.53516 96",
    stroke: "#6C7189",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7216 56.465L48.5397 56.6826L40.222 65L48.5397 73.3174C49.1534 73.9311 49.1534 74.9261 48.5397 75.5397C47.9942 76.0852 47.1475 76.1458 46.535 75.7216L46.3174 75.5397L38 67.222L29.6826 75.5397C29.0689 76.1534 28.0739 76.1534 27.4603 75.5397C26.9148 74.9942 26.8542 74.1475 27.2784 73.535L27.4603 73.3174L35.778 65L27.4603 56.6826C26.8466 56.0689 26.8466 55.0739 27.4603 54.4603C28.0058 53.9148 28.8525 53.8542 29.465 54.2784L29.6826 54.4603L38 62.778L46.3174 54.4603C46.9311 53.8466 47.9261 53.8466 48.5397 54.4603C49.017 54.9376 49.1231 55.6455 48.8579 56.2254L48.7216 56.465Z",
    fill: "#6C7189"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.c61a289f.svg";
export { ForwardRef as ReactComponent };